
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarOverlayProposal as ObiRadarOverlayProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-overlay-proposal.js';
 
 
 

 
 export const ObiRadarOverlayProposal = createComponent({
   react: React,
   tagName: 'obi-radar-overlay-proposal',
   elementClass: ObiRadarOverlayProposalElement,
   events: {
     
   }
  });
 
 